import {Components} from '@mui/material';

import {Sizes} from '@constants/sizes.constants';
import {Colors} from '@constants/colors.constants';

const drawer: Components = {
  MuiDrawer: {
    styleOverrides: {
      root: (props) => ({
        ...(!props.ownerState.hideBackdrop ? {
          backdropFilter: 'blur(4px)',
          backgroundColor: Colors.blur,
        } : {}),
        zIndex: props.ownerState.anchor === 'right' ? 1301 : undefined,
      }),
      paperAnchorDockedLeft: {
        borderRight: 'none',
        boxSizing: 'border-box',
        flexShrink: 0,
        width: Sizes.leftBar,
      },
      paperAnchorRight: {
        padding: '17px 12px 0 24px',
        width: 700,
      },
    },
  },
};

export default drawer;
